import { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";

const SettingsContext = createContext(null);
export const useSettings = () => useContext(SettingsContext);

const DEFAULTS = { nav_how: false, nav_challenge: false, nav_gallery: false, nav_blog: true, home_gallery_teaser: true, facebook_url: "", instagram_url: "", linkedin_url: "", x_url: "", youtube_url: "", tiktok_url: "" };

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(null);

  const refresh = () =>
    api.get("/public/settings").then((r) => setSettings(r.data)).catch(() => setSettings(DEFAULTS));

  useEffect(() => { refresh(); }, []);

  return (
    <SettingsContext.Provider value={{ settings: settings || DEFAULTS, loaded: settings !== null, setSettings, refresh }}>
      {children}
    </SettingsContext.Provider>
  );
}
